export default __webpack_public_path__ + "fa0031786ace70f7b66c8abff06be9c1.png";